import { memo } from "react";
import { AnimalInfo, FeedCurve } from "../../../../Services";
import { useTranslation } from "react-i18next";
import CurveInfoBox from "../../curveInfoBox";
import { ProgressBar } from "../../..";
import { ProgressTypes } from "../../../ProgressViewer/_ProgressViewer/progressDefinitions";

const InfoBoxUsage = memo(({feedCurve, animals}: {feedCurve: FeedCurve, animals: AnimalInfo[]}) => {
  const { t } = useTranslation();

  const fallbackTexts = {
    animalCount: t("negativeParams.animals", { defaultValue: "No Animals" }),
    consumedToday: t("noData", { defaultValue: "No data" })
  };

  const { cnt, total, progressed } = animals.reduce(
    (accum, animal: AnimalInfo) => {
      const consumptions = animal.consumptions ?? [];
      const const_Day = consumptions.find(
        (e) => e.milestoneDayOffset !== undefined && e.milestoneDayOffset === 0
      );
  
      if (!const_Day) return accum;
  
      accum.cnt++;
      accum.total += const_Day.total ?? 0;
      accum.progressed += const_Day.progressed ?? 0;
  
      return accum;
    },
    { cnt: 0, total: 0, progressed: 0 }
  );

  const displayData: Record<string, { value?: string | number | JSX.Element; unit?: string }> = {
    animalCount: { value: animals.length !== 0 ? animals.length : undefined, unit: animals.length === 1 ? t("units.animal", { defaultValue: "animal" }) : t("units.animals", { defaultValue: "animals" }) },
    consumedToday: { value: progressed > 0 && total > 0 ? <ProgressBar progressed={progressed} total={total} progressType={ProgressTypes.consumed} /> : undefined, unit: undefined }};

  return (
    <CurveInfoBox
      header={t("feedCurvePages.feedCurve.usage", {defaultValue: "current usage"})} 
      data={{
        displayData: displayData,
        fallbackTexts: fallbackTexts
      }}
      splitView
    />
  )
})

export default InfoBoxUsage